"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findSelectedPath = void 0;
var _isCurrentLocation = require("./isCurrentLocation");
const findSelectedPath = items => {
  for (const item of items) {
    if ((0, _isCurrentLocation.isCurrentLocation)(item.url)) {
      return item.itemPath;
    }
    if (item.subItems.length > 0) {
      const selectedPath = findSelectedPath(item.subItems);
      if (selectedPath) {
        return selectedPath;
      }
    }
  }
  return '';
};
exports.findSelectedPath = findSelectedPath;
